import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Spin } from 'antd';
import StatusButton from 'components/StatusButton';
import { useEffect, useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import { platformLabelMap } from 'services/config/platform';
import toLowerCase from 'utils/toLowerCase';
import { Footer, ResultContainer } from './styles';

const LoadingTip = styled.div`
  color: #515359;
`;
const Desc = styled.div`
  margin: 15px 0;
  text-align: center;
  width: 600px;
  white-space: pre-wrap;
`;
export interface AuthResultPendingProps {
  platform: General.PlatformCaseless;
  authWay: 'official' | 'copylink';
  onCopyURL?: (noPrefix?: boolean) => Promise<any>;
}

const AuthResultPending = (props: AuthResultPendingProps) => {
  const { platform, authWay, onCopyURL } = props;
  const { t } = useTranslate();

  const spinTip = useMemo(() => {
    const platformLabel = platformLabelMap[toLowerCase(platform)];

    return (
      <LoadingTip>
        {authWay === 'copylink' ? (
          t('authShop.正在添加店铺', { platform: platformLabel })
        ) : (
          <>
            {t('authShop.正在通过卖家中心登录', { platform: platformLabel })}
            <br />
            {t('authShop.完成添加店铺')}
          </>
        )}
      </LoadingTip>
    );
  }, [authWay, platform, t]);

  const button = useMemo(() => {
    if (authWay === 'official') {
      return (
        <StatusButton className="mt-[12px]" type="primary" onClick={() => onCopyURL(true)}>
          {t('authShop.复制链接')}
        </StatusButton>
      );
    }
    return (
      <>
        <Desc>{t('authShop.已为您生成链接')}</Desc>
        <Footer>
          <StatusButton type="primary" onClick={() => onCopyURL()}>
            {t('authShop.重新复制连接')}
          </StatusButton>
        </Footer>
      </>
    );
  }, [authWay, onCopyURL, t]);

  useEffect(() => {}, []);
  return (
    <ResultContainer>
      <Spin indicator={<LoadingOutlined />} spinning tip={spinTip} />
      {button}
    </ResultContainer>
  );
};
export default AuthResultPending;
